import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const gradients = {
  "bg-info":      "linear-gradient(135deg, #1a73e8, #0d47a1)",
  "bg-success":   "linear-gradient(135deg, #2e7d32, #1b5e20)",
  "bg-warning":   "linear-gradient(135deg, #f57c00, #e65100)",
  "bg-secondary": "linear-gradient(135deg, #455a64, #263238)",
  "bg-danger":    "linear-gradient(135deg, #c62828, #b71c1c)",
};

const InfoBox = ({ color, icon, title, message, textStyle }) => {
  const gradient = gradients[color] || gradients["bg-secondary"];

  return (
    <div style={{
      background: "#fff",
      borderRadius: "12px",
      boxShadow: "0 2px 16px rgba(0,0,0,0.09)",
      padding: "20px 24px",
      display: "flex",
      alignItems: "center",
      gap: "20px",
      marginBottom: "16px",
      overflow: "hidden",
      position: "relative",
    }}>
      <div style={{
        width: "56px",
        height: "56px",
        borderRadius: "14px",
        background: gradient,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        fontSize: "1.4rem",
        color: "#fff",
        boxShadow: "0 4px 12px rgba(0,0,0,0.18)",
      }}>
        <FontAwesomeIcon icon={icon} />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
        <span style={{ fontSize: "0.75rem", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.08em", color: "#9e9e9e" }}>
          {title}
        </span>
        <span style={{ fontSize: "1.6rem", fontWeight: 700, color: "#212121", lineHeight: 1.2, ...textStyle }}>
          {message}
        </span>
      </div>
    </div>
  );
};

export default InfoBox;
